import { Component, Input, OnChanges } from '@angular/core';
import { ITermsCulture } from './terms-culture';
import { UntypedFormGroup } from '@angular/forms';
import { IActiveTerms, IFiscalSetup } from 'src/app/xena-api';

@Component({
    selector: 'app-step3-verify',
    templateUrl: './step3-verify.component.html',
    styleUrls: ['./step3-verify.component.scss'],
    standalone: false
})
export class Step3VerifyComponent implements OnChanges {
  @Input() fiscal: IFiscalSetup;
  @Input() activeTerms: IActiveTerms[];
  @Input() form: UntypedFormGroup;
  @Input() showError: boolean = false;

  terms: ITermsCulture[] = [];

  ngOnChanges(): void {
    this.loadTerms();
  }

  loadTerms() {
    this.terms = this.activeTerms.map(at => ({
      providerId: at.providerId,
      ...at.availableCultures.find(ac => ac.culture.startsWith(this.fiscal.culture)) || at.availableCultures.find(ac => ac.culture == 'en'),
    }));
  }
}
